import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreUsersByIdPictureGetAsyncSlice } from './get';

export const coreUsersByIdPictureReducers = combineReducers({
	get: coreUsersByIdPictureGetAsyncSlice.asyncReducers
});

export const coreUsersByIdPictureWatchers = combineAllWatchers([ coreUsersByIdPictureGetAsyncSlice.asyncWatchers ]);
